import { gql } from '@apollo/client';
import { initializeApollo } from '../../apollo';
const RECORD_HOTEL_SEARCH_RESULTS = gql `
    mutation RecordHotelSearchResults($tripStateId: ID!, $hasNavl: Boolean!) {
        recordHotelSearchResults(tripStateId: $tripStateId, hasNavl: $hasNavl) {
            hasNavl
        }
    }
`;
export function hotelSearchResultsMetric(data) {
    const client = initializeApollo();
    const { hotelCount, tripStateId } = data.hotelSearchResults || {};
    client
        .mutate({
        mutation: RECORD_HOTEL_SEARCH_RESULTS,
        variables: {
            tripStateId,
            hasNavl: hotelCount === 0,
        },
    })
        .catch((error) => {
        console.error('Error in hotelSearchResultsMetric', error);
    });
}
